export class ActionCanNotBeUpdatedError extends Error {
  constructor(message?: string) {
    super(`Action can not be updated: ${message}`);
  }
}
